export const HTTP_DATA = 'HTTP_DATA'
export const REACT_DATA = 'REACT_DATA'
export const LOGIN_STATE = 'LOGIN_STATE'